import { createTheme } from "@mui/material";

export const myTheme = createTheme({
  palette: {
    primary: {
      //   light: "#07cece",
      main: "#B02E2E",
    },
  },
});
